import React, {
  useState,
  useEffect,
  useRef,
  ChangeEvent,
  FormEvent,
} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import fetchCountryOptions from "../../../scripts/countryOptions";
import { IcountryOptions } from "../../../typings/models/CountryOption";
import { countryMobileCodes } from "../../../scripts/countryMobileCodes";
import {
  savePetsRegistration,
  getOriginalOwnerDetailsById,
  getTransferDetailsById,
} from "../../../api/apimethods";
import { IPetsRegRequests } from "../../../typings/interfaces/Requests/PetsRegRequests";
import { IPetColorModel } from "../../../typings/models/PetColorModel";
import fetchColoursOption from "../../../scripts/coloursOption";
import { useNavigate, useLocation } from "react-router-dom";
import fetchAnimalTypes from "../../../scripts/animalTypes";
import { IAnimalTypesModel } from "../../../typings/models/AnimalTypesModel";
import fetchPetBreeds from "../../../scripts/petBreedOptions";
import { IPetBreedModel } from "../../../typings/models/PetBreedModel";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useConfig } from "../../../context/ConfigProvider";
import { useAuthService, useContextService } from "../../../services";
import Loader from "../../../components/molecules/Loader";

interface TabPetsProfileProps {
  onSuccessfulSubmit: () => void;
  // petsTransferApplicationId: any;
}
interface LocationState {
  //added 16/1/24
  petsRegistrationId: string;
  buttonId: string;
  tabId: string;
  bannerId: number;
  petsTransferApplicationId: string;
}

// const TabPetsProfile: React.FC = () => {
const PetsRegistrationEditForm: React.FC<TabPetsProfileProps> = ({
  onSuccessfulSubmit,
  // petsTransferApplicationId,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  let navigate = useNavigate();
  const location = useLocation(); //added 16/1/24
  let petsRegistrationId = (location.state as LocationState)
    ?.petsRegistrationId; //added 16/1/24
  let petsTransferApplicationId = (location.state as LocationState)
    ?.petsTransferApplicationId;
  const [serviceType, setServiceType] = useState<number>(0);
  const [serviceTypeSelected, setServiceTypeSelected] = useState(false);
  const [applicationType, setApplicationType] = useState("");
  const [vetCentreCode, setvetCentreCode] = useState("");
  const [animalType, setAnimalType] = useState("");
  const [animalTypeLabel, setAnimalTypeLabel] = useState("");
  const [breed, setBreed] = useState("");
  const [origin, setOrigin] = useState("");
  const [licence, setLicence] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [originCountries, setOriginCountries] = useState<IcountryOptions[]>([]);
  const [colourOptions, setColourOptions] = useState<IPetColorModel[]>([]);
  const [animalTypes, setAnimalTypes] = useState<IAnimalTypesModel[]>([]);
  const [breedOptionsByAnimalType, setBreedOptionsByAnimalType] = useState<
    Record<string, IPetBreedModel[]>
  >({});
  const [microchipNo, setMicrochipNo] = useState("");
  const [microchipDate, setMicrochipDate] = useState("");
  const [nameofPet, setNameofPet] = useState("");
  const [dateofBirthPet, setDateofBirthPet] = useState("");
  const [sex, setSex] = useState("");
  const [colour, setColour] = useState("");
  const [sterilised, setSterilised] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [blockNumber, setBlockNumber] = useState("");
  const [streetName, setStreetName] = useState("");
  const [unitNumber, setUnitNumber] = useState("");
  const [floorNumber, setFloorNumber] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [ownerIdType, setOwnerIdType] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [opostalCode, setoPostalCode] = useState("");
  const [oblockNumber, setoBlockNumber] = useState("");
  const [ostreetName, setoStreetName] = useState("");
  const [ounitNumber, setoUnitNumber] = useState("");
  const [ofloorNumber, setoFloorNumber] = useState("");
  const [obuildingName, setoBuildingName] = useState("");
  const [mobileNo, setmobileNo] = useState("");
  const [mobilecode, setMobileCode] = useState("+65");
  const [amobileNo, setamobileNo] = useState("");
  const [amobilecode, setaMobileCode] = useState("+65");
  const [email, setEmail] = useState("");
  const [remarks, setRemarks] = useState("");
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [petsRegistration, setpetsRegistrationId] =
    useState(petsRegistrationId);
  const [isCommunityCat, setisCommunityCat] = useState<any>(null);
  const [postalCodeApi, setPostalCodeApi] = useState("");
  const [blockNumberApi, setBlockNumberApi] = useState("");
  const [streetNameApi, setStreetNameApi] = useState("");
  const [unitNumberApi, setUnitNumberApi] = useState("");
  const [floorNumberApi, setFloorNumberApi] = useState("");
  const [buildingNameApi, setBuildingNameApi] = useState("");

  //valaidations
  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [ofloorNoShowError, setofloorNoShowError] = useState(true);
  const [ounitNoShowError, setounitNoShowError] = useState(true);
  const [oblockNoShowError, setoblockNoShowError] = useState(true);
  const [opostalCodeShowError, setopostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [avalidMobileNo, setaValidMobileNo] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [isMicrochipValid, setIsMicrochipValid] = useState(true);
  const [isMicrochipValidOversease, setIsMicrochipValidOversease] =
    useState(true);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
  const [addressReadOnly, setAddressReadOnly] = useState(true);

  const inputCountryRef = useRef(true);
  const inputColoursRef = useRef(true);
  const inputAnimalTypeRef = useRef(true);
  const inputPetBreedRef = useRef(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [regStatus, setRegStatus] = useState("");
  const [applicationStatus, setApplicationStatus] = useState(0);

  const [petStatus, setPetStatus] = useState<any>(null);
  const [registrationStatus, setregistrationStatus] = useState(0);
  const [petRegView, setPetRegView] = useState(true);
  const [petAddressErrorMessage, setPetAddressErrorMessage] = useState("");

  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  //Date validation
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate()); // Set it to today
  const maxdate = currentDate.toISOString().split("T")[0];

  const minDate = "1990-01-01";

  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [isMinValidDate, setisMinValidDate] = useState(true);
  const [isValidDateofBirth, setisValidDateofBirth] = useState(true);
  const [isMinValidDateofBirth, setisMinValidDateofBirth] = useState(true);
  const transferType = "PetsRegistration";

  const [isValidRegistrationId, setisValidRegistrationId] = useState(false);

  // Handle microchip  vaidation
  const handleOriginChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    // Validate the Microchip No. based on the selected "Origin"
    if (microchipNo !== "") {
      if (value === "1") {
        // Local origin validation: 15 digits, numeric
        const isValid = /^\d{15}$/.test(microchipNo);
        setIsMicrochipValid(isValid);
        setIsMicrochipValidOversease(true);
      } else if (value === "2") {
        // Overseas origin validation: No specific validation
        setIsMicrochipValid(true);
        setIsMicrochipValidOversease(true);
      }
    }
    if (value === "1") {
      const singaporeFilteredCountries = countries.filter(
        (country) => country.label === "Singapore"
      );
      setOriginCountries(singaporeFilteredCountries);
    } else if (value === "2") {
      // Overseas origin validation: No specific validation
      setOriginCountries(countries);
    }

    // Update the Microchip No. state
    setOrigin(value);
  };

  // Handle microchip  vaidation
  const handleMicrochipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    // Validate the Microchip No. based on the selected "Origin"
    if (origin === "1") {
      // Local origin validation: 15 digits, numeric
      const isValid = /^\d{15}$/.test(value);
      setIsMicrochipValid(isValid);
      setIsMicrochipValidOversease(true);
    } else if (origin === "2") {
      // Overseas origin validation: No specific validation
      setIsMicrochipValid(true);
      if (value === "") {
        setIsMicrochipValidOversease(false);
      }
    }

    // Update the Microchip No. state
    setMicrochipNo(value);
  };

  // Handle holiday vaidation
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (maxdateObj >= selectedDateObj) {
      setMicrochipDate(selectedDate);
      setisValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(false);
      setMicrochipDate("");
    }
    if (mindateObj <= selectedDateObj) {
      setMicrochipDate(selectedDate);
      setisMinValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(true);
      setisMinValidDate(false);
      setMicrochipDate("");
    }
  };

  // Handle holiday vaidation
  const handlePetbirthDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (maxdateObj >= selectedDateObj) {
      setDateofBirthPet(selectedDate);
      setisValidDateofBirth(true);
    } else {
      event.preventDefault();
      setisValidDateofBirth(false);
      setDateofBirthPet("");
    }
    if (mindateObj <= selectedDateObj) {
      setDateofBirthPet(selectedDate);
      setisMinValidDateofBirth(true);
    } else {
      event.preventDefault();
      setisValidDateofBirth(true);
      setisMinValidDateofBirth(false);
      setDateofBirthPet("");
    }
  };

  //time validation
  // const isValidTime = (time: any) => {
  //   const selectedTime = new Date(`2000-01-01T${time}`);
  //   const minTime = new Date(`2000-01-01T09:00`);
  //   const maxTime = new Date(`2000-01-01T17:00`);

  //   return selectedTime >= minTime && selectedTime <= maxTime;
  // };

  // const convertTo24HourFormat = (time: any) => {
  //   const [hours, minutes] = time.split(":");
  //   let hoursInt = parseInt(hours, 10);
  //   if (hoursInt < 12 && time.includes("PM")) {
  //     hoursInt += 12;
  //   }
  //   return `${hoursInt.toString().padStart(2, "0")}:${minutes}`;
  // };

  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value) || value === "") {
      setBlockNumber(value);
      setblockNoShowError(false);
    } else {
      setblockNoShowError(true);
    }
  };

  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (new RegExp(pattern).test(value)) {
      setPostalCode(value);
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setPostalCode(value);
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };

  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setUnitNumber(value);
      setunitNoShowError(true);
    } else {
      if (value === "") {
        setUnitNumber(value);
        setunitNoShowError(true);
      } else {
        setunitNoShowError(false);
      }
    }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (new RegExp(pattern).test(value)) {
      setFloorNumber(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setFloorNumber(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };

  const oblockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setoBlockNumber(value);
      setoblockNoShowError(true);
    } else {
      if (value === "") {
        setoBlockNumber(value);
        setoblockNoShowError(true);
      } else {
        setoblockNoShowError(false);
      }
    }
  };

  const opostalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setoPostalCode(value);
      setopostalCodeShowError(true);
    } else {
      if (value === "") {
        setoPostalCode(value);
        setopostalCodeShowError(true);
      } else {
        setopostalCodeShowError(false);
      }
    }
  };

  const ounitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setoUnitNumber(value);
      setounitNoShowError(true);
    } else {
      if (value === "") {
        setoUnitNumber(value);
        setounitNoShowError(true);
      } else {
        setounitNoShowError(false);
      }
    }
  };

  const ofloorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setoFloorNumber(value);
      setofloorNoShowError(true);
    } else {
      if (value === "") {
        setoFloorNumber(value);
        setofloorNoShowError(true);
      } else {
        setofloorNoShowError(false);
      }
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };
  const GetOnMapAddress = async (postalCode: string) => {
    const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${postalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
      console.error("Error:", response);
      return;
    }
    const data = await response.json();

    if (data.found > 0) return data.results[0];
    else return null;
  };
  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setmobileNo(value);
      if (value.length >= 8) {
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setmobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
    // Check if the selected mobile code is +65 (Singapore)
    if (mobilecode === "+65") {
      // Validate for 8 digits
      const isValid = /^[0-9]{8}$/.test(value);
      setValidMobileNo(isValid);
    } else {
      // For other country codes, no specific validation
      setValidMobileNo(true);
    }
  };

  const amobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setamobileNo(value);
      if (value.length >= 8) {
        setaValidMobileNo(true);
      } else {
        setaValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setamobileNo(value);
        setaValidMobileNo(true);
      } else {
        setaValidMobileNo(false);
      }
    }
    if (amobilecode === "+65") {
      const isValid = /^\d{8}$/.test(value);
      setaValidMobileNo(isValid);
    } else {
      setaValidMobileNo(true); // No specific validation for other country codes
    }
  };

  const toBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const base64 = await toBase64(file);
      setSelectedFile(base64);
      setSelectedFileName(file.name);
    }
  };

  const resetForm = () => {
    // Reset all the useState hooks to their initial values
    setServiceType(0);
    setServiceTypeSelected(false);
    setAnimalType("");
    setRemarks("");
    setisCommunityCat("");
    setAnimalTypeLabel("");
    setCountryOfOrigin("");
    setMicrochipNo("");
    setMicrochipDate("");
    setNameofPet("");
    setOwnerId("");
    setOwnerIdType("");
    setOwnerName("");
    setDateofBirthPet("");
    setSex("");
    setColour("");
    setOrigin("");
    setSterilised("");
    setPostalCode("");
    setBlockNumber("");
    setStreetName("");
    setUnitNumber("");
    setFloorNumber("");
    setBuildingName("");
    setOwnerId("");
    setRemarks("");
    setisCommunityCat("");
    setOwnerIdType("");
    setOwnerName("");
    setoPostalCode("");
    setoBlockNumber("");
    setoStreetName("");
    setoUnitNumber("");
    setoFloorNumber("");
    setoBuildingName("");
    setmobileNo("");
    setMobileCode("+65");
    setamobileNo("");
    setaMobileCode("+65");
    setEmail("");
    setSelectedFile(null);
    setSelectedFileName("");
    setCheckboxChecked(false);
    recaptchaRef.current?.reset();

    const form = document.querySelector(".needs-validation");
    if (form instanceof HTMLFormElement) {
      form.classList.remove("was-validated");
    }
    setSubmitted(false);
  };
  const [selectType, setSelectType] = useState<number>(0);

  const handleSelectTypeChange = (newSelectType: number) => {
    setSelectType(newSelectType);
    if (newSelectType === 1) {
      setAddressReadOnly(true);
      setPostalCode(opostalCode);
      setBlockNumber(oblockNumber);
      setStreetName(ostreetName);
      setUnitNumber(ounitNumber);
      setFloorNumber(ofloorNumber);
      setBuildingName(obuildingName);
    } else if (newSelectType === 2) {
      // Clear the address fields
      setAddressReadOnly(false);
      setPostalCode("");
      setBlockNumber("");
      setStreetName("");
      setUnitNumber("");
      setFloorNumber("");
      setBuildingName("");
    }
  };

  // const petsRegistrationId = "1";
  // const buttonId = "2";
  // const tabId = "3";
  // const bannerId = "4";

  useEffect(() => {
    // Skip the initial render check

    // if (initialRender.current) {
    //   initialRender.current = false;
    //   return;
    // }

    if (petsRegistrationId === undefined) {
      // Handle the case where petsRegistrationId is not available
      setisValidRegistrationId(true);
      setIsLoading(false);
    } else {
      try {
        const fetchData = async () => {
          var response = null;
          setpetsRegistrationId(petsRegistrationId);
          if (petsRegistrationId === undefined || petsRegistrationId === null)
            return;
          if (
            petsTransferApplicationId != null &&
            petsTransferApplicationId != undefined &&
            user.idNo != undefined &&
            user.email != undefined
          ) {
            response = await getTransferDetailsById(
              petsTransferApplicationId,
              user.idNo,
              user.email
            );
            setPetRegView(true);
          } else {
            response = await getOriginalOwnerDetailsById(petsRegistrationId);
            setPetRegView(false);
          }

          if (response.data) {
            setOwnerId(response.data.ownerIDNumber);
            setOwnerIdType(response.data.ownerID);
            setOwnerName(response.data.ownerName);
            setoPostalCode(response.data.ownerPostalCode);
            setoBlockNumber(response.data.ownerBlockHouseNumber);
            setoStreetName(response.data.ownerStreetName);
            setoUnitNumber(response.data.ownerUnitNumber);
            setoFloorNumber(response.data.ownerFloorNumber);
            setoBuildingName(response.data.ownerBuildingName);
            // setLicence(response.data.licence);

            const phnumber = response.data.ownerContactNo;
            if (phnumber && phnumber.length !== undefined) {
              const phcode = phnumber.substring(0, 3); // Extract the first 3 characters
              const number = phnumber.substring(3); // Extract the remaining characters
              setmobileNo(number);
              setMobileCode(phcode);
            } else {
              setmobileNo("");
              setMobileCode("+65");
            }

            const aphnumber = response.data.ownerAlternateContactNo;
            if (aphnumber && aphnumber.length !== undefined) {
              const phcode = aphnumber.substring(0, 3); // Extract the first 3 characters
              const number = aphnumber.substring(3); // Extract the remaining characters
              setamobileNo(number);
              setaMobileCode(phcode);
            } else {
              setamobileNo("");
              setaMobileCode("+65");
            }

            setServiceType(response.data.serviceType);
            setEmail(response.data.ownerEmail);
            setAnimalType(response.data.animalTypeID);
            setisCommunityCat(response.data.isCommunityCat);
            setRemarks(response.data.remarks);
            setBreed(response.data.breedID);
            setOrigin(response.data.petsOrigin);
            setNameofPet(response.data.petsName);
            setSex(response.data.petsSex);
            setColour(response.data.petsColourID);
            setSterilised(response.data.petsSterilised);
            setSelectType(response.data.petInformationType);
            if (response.data.microchipDate != undefined)
              setMicrochipDate(
                response.data.microchipDate.toString().split("T")[0]
              );
            setCountryOfOrigin(response.data.petsCountryOfOriginID || "");
            if (response.data.dateOfBirth != undefined)
              setDateofBirthPet(
                response.data.dateOfBirth.toString().split("T")[0]
              );

            setPostalCode(response.data.petsPostalCode);
            setBlockNumber(response.data.petsBlockHouseNumber);
            setStreetName(response.data.petsStreetName);
            setUnitNumber(response.data.petsUnitNumber);
            setFloorNumber(response.data.petsFloorNumber);
            setBuildingName(response.data.petsBuildingName);
            setMicrochipNo(response.data.petsMicrochipNo);
            setRegStatus(response.data.status);
            setApplicationStatus(response.data.applicationStatus);
            setregistrationStatus(response.data.registrationStatus);
            setApplicationType(response.data.applicationType);
            if(response.data.petStatus != undefined || response.data.petStatus != null)
              setPetStatus(response.data.petStatus);
            else
              setPetStatus(0);


            if (
              response.data.attachments != undefined &&
              response.data.attachments.length > 0
            )
              setUploadedFiles(response.data.attachments);

            if (
              response.data.petsPostalCode === response.data.ownerPostalCode &&
              response.data.petsBlockHouseNumber ===
                response.data.ownerBlockHouseNumber &&
              response.data.petsFloorNumber ===
                response.data.ownerFloorNumber &&
              response.data.petsStreetName === response.data.ownerStreetName &&
              response.data.petsUnitNumber === response.data.ownerUnitNumber &&
              response.data.petsBuildingName === response.data.ownerBuildingName
            ) {
              setSelectType(1);
              setAddressReadOnly(true);
            } else {
              setSelectType(2);
              setAddressReadOnly(false);
            }
          } else {
            // API call failed
          }
          //setCountries(countries);
          setIsLoading(false);
        };
        fetchData();
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [petsRegistrationId]);

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setOriginCountries(countries);
        setCountries(countries);
        setIsLoading(false);
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (inputColoursRef.current) {
      inputColoursRef.current = false;
      const fetchColourData = async () => {
        const petsColours = await fetchColoursOption();
        setColourOptions(petsColours);
      };

      fetchColourData();
    }
  }, []);
  const handleOwnerAddressClick = async () => {
    var address = await GetOnMapAddress(opostalCode);
    if (address) {
      setoBlockNumber(address.BLK_NO);
      setoBuildingName(address.BUILDING);
      setoStreetName(address.ROAD_NAME);
    } else {
      setoBlockNumber("");
      setoBuildingName("");
      setoStreetName("");
    }
  };
  useEffect(() => {
    if (inputAnimalTypeRef.current) {
      inputAnimalTypeRef.current = false;
      const fetchAnimalType = async () => {
        const animalTypes = await fetchAnimalTypes();
        setAnimalTypes(animalTypes);
      };

      fetchAnimalType();
    }
  }, []);

  useEffect(() => {
    if (inputPetBreedRef.current) {
      inputPetBreedRef.current = false;
      const fetchPetBreed = async () => {
        const petBreeds = await fetchPetBreeds();
        const breedOptions = petBreeds.reduce((options, petBreed) => {
          const animalTypeId = petBreed.animalType;
          options[animalTypeId] = options[animalTypeId] || [];
          options[animalTypeId].push(petBreed);
          return options;
        }, {} as Record<string, IPetBreedModel[]>);
        setBreedOptionsByAnimalType(breedOptions);
      };

      fetchPetBreed();
    }
  }, []);

  const handleCountryofOriginChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCountryOfOrigin(event.target.value);
  };

  const isServiceTypeSelected = () => {
    return serviceType !== null && serviceType !== 0;
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const handleAnimalTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedAnimalType = event.target.value;
    const selectedAnimalTypelabel =
      animalTypes.find((type) => type.id === selectedAnimalType)?.name ?? "";
    setAnimalType(selectedAnimalType);
    setAnimalTypeLabel(selectedAnimalTypelabel);
    setBreed(""); // Reset the breed when animal type changes
  };

  const handleOwnerIdTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedOwnerIdType = event.target.value;
    setOwnerIdType(selectedOwnerIdType);
  };
  if (isLoading) {
    return <Loader />;
  }

  const handlePetAddressClick = async () => {
    var address = await GetOneMapAddress(postalCode);
    if (address) {
      setBlockNumber(address.BLK_NO);
      setBuildingName(address.BUILDING);
      setStreetName(address.ROAD_NAME);
      setPetAddressErrorMessage("");
    } else {
      setBlockNumber("");
      setBuildingName("");
      setStreetName("");
      setPetAddressErrorMessage("Address not found for the postal code");
    }
  };

  const GetOneMapAddress = async (postalCode: string) => {
    const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${postalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
      console.error("Error:", response);
      return;
    }
    const data = await response.json();
    if (data.found > 0) return data.results[0];
    else return null;
  };

  // const handleSuccessfulSubmit = () => {
  //   onSuccessfulSubmit();
  // };

  const handleButtonClick = () => {
    // do not change the owner details
    const buttonId = "v-pills-homeT-tab";
    const tabId = "v-pills-homeT";
    const bannerId = 4;
    // let petsRegistrationId = data.petsRegistrationId;
    petsRegistrationId = petsRegistration;
    const isTransfer = true;
    let path = `/application-for-pets`;
    navigate(path, {
      state: { petsRegistrationId, buttonId, tabId, bannerId, isTransfer },
    });
  };

  const handleUpdateClick = async () => {
    try {
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let aServiceType = isServiceTypeSelected();
      setServiceTypeSelected(aServiceType);

      if (!reCaptchaResponse) {
        // reCAPTCHA validation failed
        setIsCaptchaValid(false);
        return;
      }

      if (isAllValidation()) {
        const PetsRegRequestData: IPetsRegRequests = {
          PetsRegistrationId: petsRegistration,
          ServiceType: serviceType,
          CentreCode: vetCentreCode,
          AnimalType: animalType,

          Breed: breed,
          LoginType:
            user.role === "SingPass"
              ? "1"
              : user.role === "CorpPass"
              ? "2"
              : "3",

          mode: 2, // edit
          PetsInformations: {
            Origin: origin,
            CountryOfOrigin: countryOfOrigin,
            MicrochipNo: microchipNo,
            MicrochipDate: microchipDate,
            PetsName: nameofPet,
            PetStatus: petStatus,
            PetsDateOfBirth: dateofBirthPet,
            PetsSex: sex,
            isCommunityCat: isCommunityCat,
            remarks: remarks,
            petInformationType: selectType,
            PetsColour: colour,
            Sterilised: sterilised,
            BlockHouseNumber: blockNumber,
            StreetName: streetName,
            FloorNumber: floorNumber,
            UnitNumber: unitNumber,
            BuildingName: buildingName,
            PostalCode: postalCode,
          },
          OwnerInformations: {
            OwnerID: ownerIdType,
            OwnerIDNumber: ownerId,
            OwnerName: ownerName,
            BlockHouseNumber: oblockNumber,
            StreetName: ostreetName,
            FloorNumber: ofloorNumber,
            UnitNumber: ounitNumber,
            BuildingName: obuildingName,
            PostalCode: opostalCode,
            OwnerContactNo: mobilecode + mobileNo,
            OwnerAlternateContactNo: amobilecode + amobileNo,
            OwnerEmail: email,
          },
          attachment: selectedFile,
          attachmentName: selectedFileName,
        };

        var response = null;

        response = await savePetsRegistration(PetsRegRequestData);
        if (response.data.data) {
          setSubmiting(false);
          const errorMessage =
            "Pet's details updated successfully for microchip" +
            " with Microchip No. " +
            microchipNo;
          alert(errorMessage);

          onSuccessfulSubmit();
        } else {
          // API call failed

          setErrorMessage("An error occurred. Please try again.");
        }

        resetForm();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (
    event:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    try {
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let aServiceType = isServiceTypeSelected();
      setServiceTypeSelected(aServiceType);

      if (!reCaptchaResponse) {
        // reCAPTCHA validation failed

        setIsCaptchaValid(false);
        return;
      }
      if (isAllValidation()) {
        const PetsRegRequestData: IPetsRegRequests = {
          PetsRegistrationId: petsRegistration,
          ServiceType: serviceType,
          CentreCode: vetCentreCode,
          AnimalType: animalType,
          Breed: breed,
          LoginType:
            user.role === "SingPass"
              ? "1"
              : user.role === "CorpPass"
              ? "2"
              : "3",

          mode: 1, // edit
          PetsInformations: {
            Origin: origin,
            CountryOfOrigin: countryOfOrigin,
            isCommunityCat: isCommunityCat,
            remarks: remarks,
            petInformationType: selectType,
            MicrochipNo: microchipNo,
            MicrochipDate: microchipDate,
            PetsName: nameofPet,
            PetStatus: petStatus,
            PetsDateOfBirth: dateofBirthPet,
            PetsSex: sex,
            PetsColour: colour,
            Sterilised: sterilised,
            BlockHouseNumber: blockNumber,
            StreetName: streetName,
            FloorNumber: floorNumber,
            UnitNumber: unitNumber,
            BuildingName: buildingName,
            PostalCode: postalCode,
          },
          OwnerInformations: {
            OwnerID: ownerIdType,
            OwnerIDNumber: ownerId,
            OwnerName: ownerName,
            BlockHouseNumber: oblockNumber,
            StreetName: ostreetName,
            FloorNumber: ofloorNumber,
            UnitNumber: ounitNumber,
            BuildingName: obuildingName,
            PostalCode: opostalCode,
            OwnerContactNo: mobilecode + mobileNo,
            OwnerAlternateContactNo: amobilecode + amobileNo,
            OwnerEmail: email,
          },
          attachment: selectedFile,
          attachmentName: selectedFileName,
        };

        var response = null;
        if (
          PetsRegRequestData.OwnerInformations.OwnerID == "2" &&
          PetsRegRequestData.OwnerInformations.OwnerIDNumber == "VX123456"
        ) {
          const errorMessage =
            "You are/This Owner ID is not allowed to register for a pet microchip.";
          setErrorMessage(errorMessage); // Set the error message in state
          return;
        }
        setSubmiting(true);
        response = await savePetsRegistration(PetsRegRequestData);
        if (response.data) {
          setSubmiting(false);

          const errorMessage =
            "You have registered a " +
            animalTypeLabel +
            " with Microchip No. " +
            microchipNo;
          alert(errorMessage);
          //setErrorMessage(errorMessage);
          //<PetsDashboard RegistrationType={""} transferType={transferType} />;
          resetForm();
          //onSuccessfulSubmit();
        } else {
          // API call failed
          setSubmiting(false);
          const errorMessage =
            "Microchip number already exists. Please try again.";
          setErrorMessage(errorMessage); // Set the error message in state
        }
        resetForm();
      }
    } catch (error) {
      // Handle any errors
      setSubmiting(false);
      console.error(error);
    }
  };

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  // let attachmentBase64 = selectedFile;

  const isAllValidation = () => {
    return isValidDate && validEmail && petStatus  && colour;
  };

  return (
    <>
      <h2 className="pb-2">Registration</h2>
      <div className="inst-cnt mt-4 mb-2">
        <span className="est-time">
          <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
        </span>
      </div>
      <form
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <div          
          id="passport"
          className="passport-details hidden csp-display-block"
        >
          <h2 className="pt-2 pb-0">Owner Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                1. Owner ID Type <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="ownerIdType"
                value={ownerIdType}
                onChange={handleOwnerIdTypeChange}
                required
                disabled
              >
                <option value=""></option>
                <option value="2">NRIC</option>
                <option value="1">FIN</option>
                <option value="4">UEN</option>
              </select>
              <div className="invalid-feedback">
                Please select Owner ID Type.
              </div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                2. Owner ID <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="ownerId"
                placeholder=""
                maxLength={25}
                value={ownerId}
                onChange={(event) => setOwnerId(event.target.value)}
                required
                readOnly
                disabled
              />
              <div className="invalid-feedback">Please provide a Owner ID.</div>
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                3. Owner Name <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="ownerName"
                placeholder=""
                maxLength={355}
                value={ownerName}
                onChange={(event) => setOwnerName(event.target.value)}
                required
                readOnly
                disabled
              />
              <div className="invalid-feedback">
                Please provide a Owner Name.
              </div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                4. Owner Address
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Postal Code
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="opostalCode"
                      name="opostalCode"
                      placeholder=""
                      maxLength={8}
                      pattern="[0-9]+"
                      value={opostalCode}
                      onChange={opostalCodeHandler}
                      disabled={
                        user.role === "SingPass" || applicationType !== null
                      }
                    />

                    {!opostalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-success d-block mt-4"
                    onClick={handleOwnerAddressClick}
                    disabled={
                      user.role === "SingPass" || applicationType !== null
                    }
                  >
                    Get Address
                  </button>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Block/House Number
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="oblockNumber"
                      placeholder=""
                      name="oblockNumber"
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={oblockNumber}
                      onChange={oblockNoHandler}
                      disabled={
                        user.role === "SingPass" || applicationType !== null
                      }
                    />
                    {!oblockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Floor Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="ofloorNumber"
                      name="ofloorNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={ofloorNumber}
                      onChange={ofloorNoHandler}
                      maxLength={3}
                      disabled={
                        user.role === "SingPass" || applicationType !== null
                      }
                    />
                    {!ofloorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Street Name
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="ostreetName"
                      placeholder=""
                      maxLength={64}
                      name="ostreetName"
                      value={ostreetName}
                      onChange={(event) => setoStreetName(event.target.value)}
                      disabled={
                        user.role === "SingPass" || applicationType !== null
                      }
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Unit Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="ounitNumber"
                      placeholder=""
                      name="ounitNumber"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={ounitNumber}
                      onChange={ounitNoHandler}
                      maxLength={4}
                      disabled={
                        user.role === "SingPass" || applicationType !== null
                      }
                    />
                    {!ounitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Building Name
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="obuildingName"
                      name="obuildingName"
                      placeholder=""
                      maxLength={64}
                      value={obuildingName}
                      onChange={(event) => setoBuildingName(event.target.value)}
                      disabled={
                        user.role === "SingPass" || applicationType !== null
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                5. Owner Contact No <span className="star">*</span>
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="mobilecode"
                    value={mobilecode}
                    onChange={(e) => setMobileCode(e.target.value)}
                    required
                    disabled={
                      user.role === "SingPass" || applicationType !== null
                    }
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className={`form-control ${
                      !validMobileNo ? "is-invalid" : ""
                    }`}
                    id="mobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={mobileNo}
                    onChange={mobileNoHandler}
                    maxLength={mobilecode === "+65" ? 8 : 66}
                    required
                    disabled={
                      user.role === "SingPass" || applicationType !== null
                    }
                  />
                  {!validMobileNo && (
                    <div className="invalid-feedback">
                      Please provide a valid Contact No.
                    </div>
                  )}
                  {mobilecode === "+65" && !validMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                6. Owner alternate Contact No.
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="amobilecode"
                    value={amobilecode}
                    onChange={(e) => setaMobileCode(e.target.value)}
                    disabled={
                      user.role === "SingPass" || applicationType !== null
                    }
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className={`form-control ${
                      !avalidMobileNo ? "is-invalid" : ""
                    }`}
                    id="amobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={amobileNo}
                    onChange={amobileNoHandler}
                    maxLength={amobilecode === "+65" ? 8 : 66}
                    disabled={
                      user.role === "SingPass" || applicationType !== null
                    }
                  />
                  {!avalidMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                7. Owner Email<span className="star">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder=""
                maxLength={255}
                value={email}
                onChange={handleEmailChange}
                disabled
              />
              <div className="invalid-feedback">Please provide a Email.</div>
              {!validEmail && (
                <p className="error-message">
                  Invalid email format. eg. abc@de.lk
                </p>
              )}
            </div>
          </div>
          <h2 className="pb-0">Pet Information</h2>
          <div className="inst-cnt mt-2">
            {/* components should be there */}
            {/* <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                8. Pet Licence
              </label>
              <input
                type="text"
                className="form-control"
                id="licence"
                placeholder=""
                maxLength={355}
                value={licence}
                onChange={(event) => setLicence(event.target.value)}
                disabled={true}
              />
              <div className="invalid-feedback">Please provide a licence.</div>
            </div> */}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isServiceTypeSelected() ? "required" : ""
                }`}
              >
                8. This request for service is for{" "}
                <span className="star">*</span>{" "}
              </label>
              <div
                className={`form-check ${
                  !isServiceTypeSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="serviceType"
                  value="Myself"
                  id="flexRadioDefault66"
                  checked={serviceType === 1}
                  onChange={() => setServiceType(1)}
                  readOnly
                  disabled
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault66"
                >
                  Myself
                </label>
              </div>
              <div
                className={`form-check ${
                  !isServiceTypeSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="serviceType"
                  value="Organisation"
                  id="flexRadioDefault77"
                  checked={serviceType === 2}
                  onChange={() => setServiceType(2)}
                  readOnly
                  disabled
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault77"
                >
                  Organisation
                </label>
              </div>
              <div
                className={`form-check ${
                  !isServiceTypeSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="serviceType"
                  value="Organisation"
                  id="flexRadioDefault88"
                  checked={serviceType === 3}
                  onChange={() => setServiceType(3)}
                  readOnly
                  disabled
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault88"
                >
                  On Behalf of Owner
                </label>
              </div>
              {submitted && !isServiceTypeSelected() && (
                <div className="invalid-feedback">
                  Please select a Service Type.
                </div>
              )}
            </div>
            {/* <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                2. Vet Centre Code
              </label>
              <input
                type="text"
                className="form-control"
                id="VetCentreCode"
                placeholder=""
                maxLength={15}
                value={vetCentreCode}
                onChange={(event) => setvetCentreCode(event.target.value)}
              />
            </div> */}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                9. Animal Type <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="animalType"
                value={animalType}
                onChange={handleAnimalTypeChange}
                required
                disabled
              >
                <option value=""></option>
                {animalTypes.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
              <div className="invalid-feedback">
                Please provide an Animal Type.
              </div>
            </div>
            {animalType === "e0df8145-1d5d-ed11-9561-0022485935af" && (
              <>
                <div className="mb-2">
                  <label htmlFor="isCommunityCat" className="form-label mb-2">
                    Community Cat
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="isCommunityCat"
                      value={1}
                      id="communityCatYes"
                      checked={isCommunityCat === 1}
                      onChange={() => setisCommunityCat(1)}
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="communityCatYes"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="isCommunityCat"
                      value={0}
                      id="communityCatNo"
                      checked={isCommunityCat === 0}
                      onChange={() => setisCommunityCat(0)}
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="communityCatNo"
                    >
                      No
                    </label>
                  </div>
                </div>
              </>
            )}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                10. Breed <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="breed"
                value={breed}
                onChange={(e) => setBreed(e.target.value)}
                required
                disabled
              >
                <option value=""></option>
                {breedOptionsByAnimalType[animalType]?.map(
                  (breedOption: IPetBreedModel, index: number) => (
                    <option key={index} value={breedOption.id}>
                      {breedOption.breedName}
                    </option>
                  )
                )}
              </select>
              <div className="invalid-feedback">Please provide a Breed.</div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                11. Origin <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="origin"
                value={origin}
                onChange={handleOriginChange}
                required
                disabled
              >
                <option value=""></option>
                <option value="1">Local</option>
                <option value="2">Overseas</option>
              </select>
              <div className="invalid-feedback">Please select Origin.</div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                12. Country of Origin{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="countryOfOrigin"
                value={countryOfOrigin}
                onChange={handleCountryofOriginChange}
                disabled
              >
                {/* <option value=""></option> */}
                {originCountries.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                13. Microchip No.
                <span className="star">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  !isMicrochipValid ? "is-invalid" : ""
                }`}
                id="microchipNo"
                placeholder=""
                value={microchipNo}
                onChange={handleMicrochipChange}
                maxLength={origin === "1" ? 15 : 15}
                required
                disabled
              />
              {/* {!isMicrochipValid && (
                <div className="invalid-feedback">
                  Please enter a valid Microchip No. Digits 0 to 9, and should
                  have 15 digits only.
                </div>
              )}
              {!isMicrochipValidOversease && (
                <div className="invalid-feedback">
                  Please enter a valid Microchip No. Letters: A to Z. Digits: 0
                  to 9.
                </div>
              )} */}
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                14. Microchip Date <span className="star">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="microchipDate"
                value={microchipDate}
                onChange={handleDateChange}
                max={maxdate}
                required
                min={minDate}
                readOnly
                disabled
              />
              {isValidDate && (
                <div className="invalid-feedback">
                  Please provide a Microchip Date.
                </div>
              )}
              {!isMinValidDate && (
                <p className="error-message">Please enter a valid year.</p>
              )}

              {!isValidDate && (
                <p className="error-message">
                  Microchip Date cannot be later than today's date.
                </p>
              )}
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                15. Name of Pet
              </label>
              <input
                type="text"
                className="form-control"
                id="nameofPet"
                placeholder=""
                maxLength={255}
                value={nameofPet}
                onChange={(event) => setNameofPet(event.target.value)}
                disabled={
                  registrationStatus === 3 ||
                  registrationStatus === 5 ||
                  applicationType !== null
                }
              />
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                16. Date of Birth <span className="star">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="dateofBirthPet"
                value={dateofBirthPet}
                onChange={handlePetbirthDateChange}
                max={maxdate}
                min={minDate}
                readOnly
                disabled
              />
              {isValidDateofBirth && (
                <div className="invalid-feedback">
                  Please provide a Date of Birth.
                </div>
              )}

              {!isMinValidDateofBirth && (
                <p className="error-message">Please enter a valid year.</p>
              )}

              {!isValidDateofBirth && (
                <p className="error-message">
                  Date of Birth cannot be later than today's date.
                </p>
              )}
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                17. Sex <span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="sex"
                value={sex}
                onChange={(e) => setSex(e.target.value)}
                required
                disabled
              >
                <option value=""></option>
                <option value="1">Male</option>
                <option value="2">Female</option>
              </select>
              <div className="invalid-feedback">Please provide a Sex.</div>
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                18. Colour<span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="colour"
                value={colour}
                onChange={(e) => setColour(e.target.value)}
                required
                disabled={
                  registrationStatus === 3 ||
                  registrationStatus === 5 ||
                  applicationType !== null
                }
              >
                {colourOptions.map((colour) => (
                  <option key={colour.petColorID} value={colour.petColorID}>
                    {colour.colorName}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                19. Sterilised <span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="sterilised"
                value={sterilised}
                onChange={(e) => setSterilised(e.target.value)}
                required
                disabled={
                  registrationStatus === 3 ||
                  registrationStatus === 5 ||
                  applicationType !== null
                }
              >
                <option value=""></option>
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>

              {submitted &&
                !sterilised &&
                registrationStatus !== 3 &&
                registrationStatus !== 5 && (
                  <div className="error-message">
                    Please Provide Sterilised.
                  </div>
                )}
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                20. Pet Status Test<span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="petstatus"
                value={petStatus}
                onChange={(e) => setPetStatus(parseInt(e.target.value))}
                disabled={
                  registrationStatus === 3 ||
                  registrationStatus === 5 ||
                  applicationType !== null
                }
              >
                <option value={0}>--- Select ---</option>
                <option value={1}>Deceased</option>
                <option value={2}>Missing</option>
                <option value={3}>Exported</option>
                <option value={4}>Active</option>
              </select>

              {submitted &&
                !petStatus &&
                registrationStatus !== 2 &&
                registrationStatus !== 5 && (
                  <div className="error-message">
                    Please provide Pet Status.
                  </div>
                )}
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                21. Pet Address
              </label>
              <div className="mb-2">
                <div
                  className={`form-check ${!selectType ? "is-invalid" : ""}`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectType"
                    value="1"
                    id="sameAsOwnerRadio"
                    checked={selectType === 1}
                    onChange={() => handleSelectTypeChange(1)}
                    disabled={
                      registrationStatus === 3 ||
                      registrationStatus === 5 ||
                      applicationType !== null
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="sameAsOwnerRadio"
                  >
                    Same as owner
                  </label>
                </div>
                <div
                  className={`form-check ${!selectType ? "is-invalid" : ""}`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectType"
                    value="2"
                    id="otherAddressRadio"
                    checked={selectType === 2}
                    onChange={() => handleSelectTypeChange(2)}
                    disabled={
                      registrationStatus === 3 ||
                      registrationStatus === 5 ||
                      applicationType !== null
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="otherAddressRadio"
                  >
                    Other address
                  </label>
                </div>
                {submitted && !selectType && (
                  <div className="invalid-feedback">Please select a Type.</div>
                )}
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Postal Code
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="postalCode"
                      placeholder=""
                      maxLength={8}
                      pattern="[0-9]+"
                      value={postalCode}
                      onChange={postalCodeHandler}
                      readOnly={addressReadOnly}
                      disabled={
                        registrationStatus === 3 ||
                        registrationStatus === 5 ||
                        applicationType !== null
                      }
                    />

                    {!postalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                    {petAddressErrorMessage && (
                      <p className="error-message">{petAddressErrorMessage}</p>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-success d-block mt-4"
                    onClick={handlePetAddressClick}
                    disabled={
                      selectType === 1 ||
                      registrationStatus === 3 ||
                      registrationStatus === 5 ||
                      applicationType !== null
                    }
                  >
                    Get Address
                  </button>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Block/House Number
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="blockNumber"
                      placeholder=""
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={blockNumber}
                      onChange={blockNoHandler}
                      readOnly={addressReadOnly}
                      disabled={
                        registrationStatus === 3 ||
                        registrationStatus === 5 ||
                        applicationType !== null
                      }
                    />
                    {!blockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Floor Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="floorNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={floorNumber}
                      onChange={floorNoHandler}
                      maxLength={3}
                      readOnly={addressReadOnly}
                      disabled={
                        registrationStatus === 3 ||
                        registrationStatus === 5 ||
                        applicationType !== null
                      }
                    />
                    {!floorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Street Name
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="streetName"
                      placeholder=""
                      maxLength={64}
                      value={streetName}
                      onChange={(event) => setStreetName(event.target.value)}
                      readOnly={addressReadOnly}
                      disabled={
                        registrationStatus === 3 ||
                        registrationStatus === 5 ||
                        applicationType !== null
                      }
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Unit Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="unitNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={unitNumber}
                      onChange={unitNoHandler}
                      maxLength={4}
                      readOnly={addressReadOnly}
                      disabled={
                        registrationStatus === 3 ||
                        registrationStatus === 5 ||
                        applicationType !== null
                      }
                    />
                    {!unitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Building Name
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="buildingName"
                      placeholder=""
                      maxLength={64}
                      value={buildingName}
                      onChange={(event) => setBuildingName(event.target.value)}
                      readOnly={addressReadOnly}
                      disabled={
                        registrationStatus === 3 ||
                        registrationStatus === 5 ||
                        applicationType !== null
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                22. Remarks
              </label>
              <textarea
                className="form-control"
                id="remarks"
                placeholder=""
                maxLength={200}
                value={remarks}
                onChange={(event) => setRemarks(event.target.value)}
                disabled={
                  registrationStatus === 3 ||
                  registrationStatus === 5 ||
                  applicationType !== null
                }
              />
              <p>{remarks ? remarks.length : 0}/200</p>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="pdfUpload" className="form-label">
              Attachment
            </label>
            <input
              type="file"
              className="form-control"
              id="pdfUpload"
              onChange={handleFileChange}
              accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              disabled
            />
          </div>
          {uploadedFiles &&
            uploadedFiles.length > 0 &&
            uploadedFiles.map((fileName) => (
              <div>
                <p>Uploaded File: {fileName}</p>
                {/* <p>File Size: {file.size} bytes</p> */}
              </div>
            ))}

          {registrationStatus !== 3 &&
            registrationStatus !== 5 &&
            applicationType === null && (
              <div className="mb-3">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={site_Key}
                  onChange={() => setIsCaptchaValid(true)}
                  onExpired={() => setIsCaptchaValid(false)}
                />
                {submitted && !isCaptchaValid && (
                  <div className="error-message">
                    Please complete the reCAPTCHA verification.
                  </div>
                )}
              </div>
            )}

          <div className="form-buttons">
            {registrationStatus !== 3 &&
              registrationStatus !== 5 &&
              applicationType === null && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleUpdateClick}
                >
                  Update
                </button>
              )}
            {registrationStatus !== 3 &&
              registrationStatus !== 5 &&
              applicationType === null && (
                <button
                  type="button"
                  className={`btn btn-success`}
                  onClick={handleButtonClick}
                >
                  Owner Transfer
                </button>
              )}
          </div>

          {/* <h2>Declaration</h2>
          <div className="inst-cnt mb-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={checkboxChecked}
                onChange={handleCheckboxChange}
                id="flexCheckDefault"
                required
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                declaration message needed
              </label>
              {submitted && !checkboxChecked && (
                <p className="error-message">
                  Please confirm the declaration checkbox
                </p>
              )}
            </div>
          </div> */}

          {/* <button type="submit" className="btn btn-success d-block mt-4">
            Submit
          </button>
          {isSubmiting && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )} */}

          {errorMessage && <p>{errorMessage}</p>}
        </div>
      </form>
    </>
  );
};

export default PetsRegistrationEditForm;
